import src from "IMAGE";
export default { src, width: 685, height: 685, blurWidth: 0, blurHeight: 0};
